import './filters-modal.scss';

import { Button, Form } from 'antd';
import { useTranslation } from 'react-i18next';

import Modal from '../modal';

interface IProps {
  open: boolean;
  onClose: () => void;
  /** «Сбросить»: снять фильтры списка; модалка остаётся открытой, как в лизинге. */
  onReset: () => void;
  /** «Применить»: записать фильтры и закрыть модалку. */
  onApply: () => void;
  /** Поля фильтров — antd `Form.Item` с контролами. */
  children: React.ReactNode;
}

/**
 * Оболочка модалки фильтров реестра: заголовок, подсказка, поля и кнопки
 * «Сбросить» / «Применить». Состояние полей и запись в адрес — у модалки страницы.
 */
const FiltersModal: React.FC<IProps> = ({
  open,
  onClose,
  onReset,
  onApply,
  children
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('common.filters.title')}
      className="filters-modal"
    >
      {({ classes }) => (
        <Form layout="vertical" onFinish={onApply}>
          <p className="filters-modal__hint">{t('common.filters.hint')}</p>
          <div className="filters-modal__fields">{children}</div>
          <div className={classes.actions}>
            <Button onClick={onReset}>{t('common.filters.reset')}</Button>
            <Button type="primary" htmlType="submit">
              {t('common.filters.apply')}
            </Button>
          </div>
        </Form>
      )}
    </Modal>
  );
};

export default FiltersModal;
